module.exports = __webpack_public_path__ + "img/062_thumbnail.dcdd4e8a.jpg";